<template>
  <svg :width="size" :height="size" viewBox="0 0 24 24" fill="none"
    :stroke="color" :stroke-width="stroke" stroke-linecap="round" stroke-linejoin="round">
    <template v-if="name === 'search'">
      <circle cx="11" cy="11" r="7"/>
      <path d="M21 21l-4.3-4.3"/>
    </template>
    <template v-else-if="name === 'cart'">
      <path d="M3 3h2l2 12h11l2-8H6"/>
      <circle cx="9" cy="20" r="1.5"/>
      <circle cx="17" cy="20" r="1.5"/>
    </template>
    <template v-else-if="name === 'plus'">
      <path d="M12 5v14M5 12h14"/>
    </template>
    <template v-else-if="name === 'minus'">
      <path d="M5 12h14"/>
    </template>
    <template v-else-if="name === 'check'">
      <path d="M5 12l5 5L20 7"/>
    </template>
    <template v-else-if="name === 'chev'">
      <path d="M9 6l6 6-6 6"/>
    </template>
    <template v-else-if="name === 'chevD'">
      <path d="M6 9l6 6 6-6"/>
    </template>
    <template v-else-if="name === 'close'">
      <path d="M6 6l12 12M6 18L18 6"/>
    </template>
    <template v-else-if="name === 'bolt'">
      <path d="M13 2L3 14h8l-1 8 10-12h-8l1-8z"/>
    </template>
    <template v-else-if="name === 'refresh'">
      <path d="M21 12a9 9 0 11-3-6.7L21 8"/>
      <path d="M21 3v5h-5"/>
    </template>
    <template v-else-if="name === 'grid'">
      <rect x="3" y="3" width="7" height="7"/>
      <rect x="14" y="3" width="7" height="7"/>
      <rect x="3" y="14" width="7" height="7"/>
      <rect x="14" y="14" width="7" height="7"/>
    </template>
    <template v-else-if="name === 'list'">
      <path d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01"/>
    </template>
    <template v-else-if="name === 'matrix'">
      <rect x="3" y="3" width="18" height="18" rx="1"/>
      <path d="M9 3v18M3 9h18M3 15h18M15 3v18"/>
    </template>
    <template v-else-if="name === 'edit'">
      <path d="M12 20h9"/>
      <path d="M16.5 3.5a2.1 2.1 0 113 3L7 19l-4 1 1-4 12.5-12.5z"/>
    </template>
    <template v-else-if="name === 'user'">
      <circle cx="12" cy="8" r="4"/>
      <path d="M4 21c0-4 4-7 8-7s8 3 8 7"/>
    </template>
    <template v-else-if="name === 'pkg'">
      <path d="M21 8l-9-5-9 5 9 5 9-5z"/>
      <path d="M3 8v8l9 5 9-5V8"/>
      <path d="M12 13v8"/>
    </template>
    <template v-else-if="name === 'clock'">
      <circle cx="12" cy="12" r="9"/>
      <path d="M12 7v5l3 2"/>
    </template>
    <template v-else-if="name === 'truck'">
      <rect x="1" y="6" width="14" height="10"/>
      <path d="M15 9h4l3 3v4h-7"/>
      <circle cx="5.5" cy="18.5" r="2"/>
      <circle cx="18.5" cy="18.5" r="2"/>
    </template>
    <template v-else-if="name === 'star'">
      <path d="M12 3l3 6 7 1-5 5 1 7-6-3-6 3 1-7-5-5 7-1z"/>
    </template>
    <template v-else-if="name === 'location'">
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 1118 0z"/>
      <circle cx="12" cy="10" r="3"/>
    </template>
    <template v-else-if="name === 'receipt'">
      <path d="M5 2v20l3-2 3 2 3-2 3 2 3-2V2H5z"/>
      <path d="M9 7h6M9 11h6M9 15h4"/>
    </template>
    <template v-else-if="name === 'door'">
      <path d="M9 3h6v18H9z"/>
      <path d="M9 12h.01"/>
      <path d="M3 21h18"/>
    </template>
    <template v-else-if="name === 'download'">
      <path d="M12 3v14"/>
      <path d="M5 12l7 7 7-7"/>
      <path d="M5 21h14"/>
    </template>
  </svg>
</template>

<script setup>
defineProps({
  name:   { type: String, required: true },
  size:   { type: Number, default: 16 },
  color:  { type: String, default: 'currentColor' },
  stroke: { type: Number, default: 1.7 },
})
</script>
